import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { List } from 'foundations-components/transitional/components/List';
import { PPUIGridItem } from 'pricing-pages-ui-components/grid/PPUIGridItem';
import { AllCombinedProductLines } from 'self-service-api/constants/AllCombinedProductLines';
import { FREE } from 'self-service-api/constants/ProductLevels';
import { ProductLevelAndProductLineToSuiteBOTranslationKeyMap, ProductLevelToSuiteBOHeaderTranslationKeyMap } from '../../../constants/BusinessObjectivesTranslationKeys';
import ProductIcon from '../../common/ProductIcon';
import SuiteBusinessObjectivesSubtext from './SuiteBusinessObjectivesSubtext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const SuiteBusinessObjectives = ({
  productLevel
}) => {
  const DisplayedProductLines = AllCombinedProductLines;
  // In order for the grid to work, we need this to remain enclosed in a Fragment and not a div.
  // Children of the display grid item must get the grid-start attributes directly
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(PPUIGridItem, {
      paddingBlockStart: "800",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: ProductLevelToSuiteBOHeaderTranslationKeyMap[productLevel]
      })
    }), /*#__PURE__*/_jsx(PPUIGridItem, {
      paddingBlockEnd: "600",
      children: /*#__PURE__*/_jsx(List, {
        children: DisplayedProductLines.map(localProductLine => {
          return /*#__PURE__*/_jsxs(Flex, {
            marginBlock: "300",
            alignItems: "center",
            children: [/*#__PURE__*/_jsx(ProductIcon, {
              name: localProductLine,
              iconStyle: {
                blockSize: '32px',
                marginInlineEnd: '300'
              }
            }), /*#__PURE__*/_jsxs("div", {
              children: [/*#__PURE__*/_jsx(Text, {
                typography: productLevel !== FREE ? 'body-125' : undefined,
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: ProductLevelAndProductLineToSuiteBOTranslationKeyMap[productLevel][localProductLine].title
                })
              }), /*#__PURE__*/_jsx("div", {
                children: /*#__PURE__*/_jsx(SuiteBusinessObjectivesSubtext, {
                  productLevel: productLevel,
                  productLine: localProductLine
                })
              })]
            })]
          }, localProductLine);
        })
      })
    })]
  });
};
export default SuiteBusinessObjectives;